import { Component, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { PathwayFacade } from '@app/store/pathway';
import { PathwayType } from '@app/store/shared/models';
import { EntityListComponent, UnavailableComponent } from '@shared/components';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { getTypeOptions } from '../list/config/type-options';

@Component({
    selector: 'app-predefined-pathway-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, ButtonModule, TagModule, EntityListComponent, UnavailableComponent, DeleteButtonComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly pathwayFacade = inject(PathwayFacade);
    private readonly translateService = inject(TranslateService);

    readonly pathway = this.pathwayFacade.pathway;
    readonly loading = this.pathwayFacade.loading;
    readonly saving = this.pathwayFacade.saving;
    readonly error = this.pathwayFacade.error;

    private readonly typeOptions = getTypeOptions(this.translateService);

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.pathwayFacade.getPathway(id);
        }
    }

    ngOnDestroy(): void {
        this.pathwayFacade.clear();
    }

    typeLabel(type: PathwayType): string {
        return this.typeOptions.find((option) => option.value === type)?.label ?? type;
    }

    onEdit(id: string): void {
        this.router.navigate([{ outlets: { modal: ['predefined-pathways', 'edit', id] } }]);
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
